export function validatePhone(phoneInput) {
    let isValid = false

    function isValidPhone(phone) {
        if (phone.length !== 0 && phone.length < 11) {
            updateErrorMessage(true);
            isValid = false;
        } else {
            updateErrorMessage(false);
            isValid = true;
        }
    }

    function updateErrorMessage(displayError) {
        const errorMessage = document.getElementById('error-message-phone');
        errorMessage.style.display = displayError ? 'flex' : 'none';
        if (displayError) {
            phoneInput.classList.add('form__input--error');
        } else {
            phoneInput.classList.remove('form__input--error')
        }
    }

    phoneInput.addEventListener('input', function (event) {
        let eventValue = event.target.value;
        applyMask(eventValue);

        const phoneValidityEvent = new CustomEvent('phoneValidity', {
            detail: { isValid }
        });

        document.dispatchEvent(phoneValidityEvent);
    });


    function applyMask(eventValue) {
        if (eventValue) {
            let newVal = eventValue.trim();

            if (eventValue.trim() === '+48') {
                newVal = '+48 '; // backspace case
            } else {
                newVal = newVal.replace(/\D/g, '');
                if (!newVal.startsWith('48')) {
                    newVal = '48' + newVal;
                }

                //11 because that's the length of phone number with country code without dashes, spaces, '+', etc.
                newVal = newVal.substring(0, Math.min(newVal.length, 11));
                isValidPhone(newVal);

                if (newVal.length > 8) {
                    newVal = newVal.replace(
                        /^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,3})$/g,
                        '+$1 $2-$3-$4'
                    );
                } else if (newVal.length > 5) {
                    newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})$/g, '+$1 $2-$3');
                } else if (newVal.length > 2) {
                    newVal = newVal.replace(/^(\d{0,2})(\d{0,3})$/g, '+$1 $2');
                } else {
                    newVal = '+' + newVal;
                }
            }
            phoneInput.value = newVal;
        }
    }
}